import {Locale} from '@lookiero/style-profile';
import {useEffect, useState} from 'react';
import {viewLocaleHandler} from '../../../locale/core/infrastructure/projection/viewLocale';
import {viewLocale} from '../../../locale/core/projection/viewLocale';
import {viewCustomer} from '../../../customer/core/projection/viewCustomer';
import {viewCustomerHandler} from '../../../customer/core/infrastructure/projection/viewCustomer';
import {Customer as StyleProfileCustomer, Country} from '@lookiero/style-profile';
import {useApp} from '../../../../ui/app';

interface UseViewCustomerAndLocaleFunctionReturn {
  readonly customer: StyleProfileCustomer | null;
  readonly locale: Locale | null;
}

interface UseViewCustomerAndLocaleFunction {
  (): UseViewCustomerAndLocaleFunctionReturn;
}

const useViewCustomerAndLocale: UseViewCustomerAndLocaleFunction = () => {
  const {authorization} = useApp();
  const [styleProfileCustomer, setStyleProfileCustomer] = useState<StyleProfileCustomer | null>(null);
  const [locale, setLocale] = useState<Locale | null>(null);

  useEffect(() => {
    const loadCustomer = async (): Promise<void> => {
      const customer = await viewCustomerHandler(viewCustomer());
      if (customer) {
        setStyleProfileCustomer({
          customerId: customer.customerId,
          country: customer.country as Country,
          segment: customer.segment,
        });
      }
    };

    loadCustomer();
  }, [authorization]);

  useEffect(() => {
    const loadLocale = async (): Promise<void> => {
      setLocale((await viewLocaleHandler(viewLocale())) as Locale);
    };

    loadLocale();
  }, []);

  return {
    customer: styleProfileCustomer,
    locale,
  };
};

export {useViewCustomerAndLocale};
